module.exports = __webpack_public_path__ + "static/index/img/baikal-205.41757020.jpg";